import React from "react";
import TableCell from "./TableCell";


const TableRowOverlay = (props) => {

    return(
        <div className="finderTable-row-overlay">
            {props.row.slice(props.config.numberColsVisible).map((cell, index) => {
                return (cell && cell.v && <div key={index} className="finderTable-row-overlay-cell"><span className="table-row-cell-overlay-title">{props.header[index+props.config.numberColsVisible]?.v}</span><span className="table-row-cell-overlay-value"> <TableCell cell={cell}/></span></div>);
            })}
        </div>
    )
};

export default TableRowOverlay;
